import { BaseStorageService } from './base-storage.service';

export class LocalStorageService extends BaseStorageService {
  constructor() {
    super();
    if (typeof window !== 'undefined') {
      this.storage = localStorage;
    }
  }
}

export const localStorageService = new LocalStorageService();
